import { Toaster } from 'react-hot-toast';
import { ink, paper, status } from "../theme/palette";

const CustomToaster = () => (
  <Toaster
    position="top-center"
    toastOptions={{
      duration: 4000,
      style: {
        background: ink,
        color: paper,
      },
      success: {
        duration: 3000,
        iconTheme: {
          primary: status.success,
          secondary: paper,
        },
      },
      error: {
        duration: 5000,
        iconTheme: {
          primary: status.danger,
          secondary: paper,
        },
      },
    }}
  />
);

export default CustomToaster;